/**
 * SAD-143: the caller's own assigned actions, tenant-wide, on the global
 * Dashboard. This is the only surface a program non-member with a directly
 * assigned Correction can reach it from — Program Home's "Mine" group and
 * the Workroom signals panel both live behind full program access.
 *
 * Reuses AssignedActionList/useMyAssignedActions verbatim (no fork, no new
 * RPC); enableResolve swaps a Correction row's navigation — which would be a
 * dead end for a caller with no view of that program — for an inline Resolve
 * affordance.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { AssignedActionList } from '../../components/delivery/widgets/AssignedActionList';
import { useMyAssignedActions } from '../../components/delivery/widgets/useMyAssignedActions';
const ASSIGNED_ROW_CAP = 5;
const ASSIGNED_TESTIDS = {
    container: Testids.dashboard.assignedContainer,
    row: Testids.dashboard.assignedRow,
    empty: Testids.dashboard.assignedEmpty,
    error: Testids.dashboard.assignedError,
    more: Testids.dashboard.assignedMore,
    resolve: Testids.dashboard.assignedResolve
};
export function MyAssignedActionsCard() {
    // Same query (and cache entry) AssignedActionList makes below — read only
    // far enough to decide whether this section has anything to say. Most
    // tenant staff have no linked contact record at all, and a "Assigned to
    // you" heading sitting above nothing would read as broken, not empty.
    const { data, isLoading, isError } = useMyAssignedActions();
    if (!isLoading && !isError && !data?.callerHasLinkedContact) return null;
    return /*#__PURE__*/ _jsxs("section", {
        className: "mb-8",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mb-3.5 flex items-baseline justify-between",
                children: /*#__PURE__*/ _jsx("h2", {
                    className: "text-sm font-medium text-foreground",
                    children: "Assigned to you"
                })
            }),
            /*#__PURE__*/ _jsx(AssignedActionList, {
                cap: ASSIGNED_ROW_CAP,
                enableResolve: true,
                testids: ASSIGNED_TESTIDS
            })
        ]
    });
}
